import * as React from "react";
import BaseLayout from "../../components/BaseLayout";
import ReportsMain from "../../features/Report/ReportsMain";

function ReportsPage() {
  return (
    <BaseLayout>
      <ReportsMain />
    </BaseLayout>
  );
}

export default ReportsPage;
